module.exports = __webpack_public_path__ + "kibervarnost/media/za-profilno-sliko-je-lahko-kdorkoli.db62b32c.webm";